angular.module('impactx.monitordashboard').controller('MonitorDashboardCtrl', [
    '$scope',
    '$timeout',
    'dataGen',
    '$locale',
    '$context',
    'NewCubeService',
    'ToolbarService',
    '$securityManager',
    MonitorDashboardCtrl
]);

function MonitorDashboardCtrl($scope, $timeout, dataGen, $locale, $context, NewCubeService, ToolbarService, $securityManager) {
    var self = this;
    self.open = NewCubeService.open;

    /* initial states */
    var pattern = {
            "gSize": 3,
            "lgSize": 3,
            "maxFrac": 2,
            "minFrac": 0,
            "negPre": "-",
            "negSuf": "",
            "posPre": "",
            "posSuf": ""
        };
    var formats = $locale.NUMBER_FORMATS;

    /* watcher for input fields */
    $scope.$watch(function () {
            if ($scope.data
                && $scope.data.timePeriod
                && $scope.data.timePeriod.selected
                && $scope.data.timePeriod.selected.id)
                return $scope.data.timePeriod.selected.id;
        },
        function (newValue, oldValue) {
            if (newValue != oldValue && newValue != 0 && oldValue) {
                var tempScope = {};
                dataGen.getData(tempScope, {timeperiod: newValue}, "/monitor/dashboardwithperiod").then(
                    function () {
                        $scope.data.quickStatsData.quickStatPanels = tempScope.data.quickStatsData.quickStatPanels;
                        $scope.data.quickStatsData.searchStringData = tempScope.data.quickStatsData.searchStringData;

                        $scope.data.totalNetDataPeriod.mainData.data = tempScope.data.totalNetDataPeriod.mainData.data;
                        $scope.data.totalNetDataPeriod.mainData.totalNet = tempScope.data.totalNetDataPeriod.mainData.totalNet;
                        $scope.data.totalNetDataPeriod.mainData.totalNetValue = tempScope.data.totalNetDataPeriod.mainData.totalNetValue;
                        $scope.data.totalNetDataPeriod.compareData.data = tempScope.data.totalNetDataPeriod.compareData.data;
                        $scope.data.totalNetDataPeriod.compareData.totalNet = tempScope.data.totalNetDataPeriod.compareData.totalNet;
                        $scope.data.totalNetDataPeriod.compareData.totalNetValue = tempScope.data.totalNetDataPeriod.compareData.totalNetValue;
                        $scope.totalNetDataPeriod = generateTotalNetDataPeriod();

                        $scope.data.orderData.mainData.data = tempScope.data.orderData.mainData.data;
                        $scope.data.orderData.mainData.totalOrderCount = tempScope.data.orderData.mainData.totalOrderCount;
                        $scope.data.orderData.compareData.data = tempScope.data.orderData.compareData.data;
                        $scope.data.orderData.compareData.totalOrderCount = tempScope.data.orderData.compareData.totalOrderCount;
                        $scope.orderChartData = generateOrderData();

                        $timeout(function () {
                            textFit($(".quickStat"));
                        }, 0);
                    }
                );
            }
        }, true);

    /* initial get command */
    if ($context.hasCompany() && $securityManager.isProcessAllowed("ContentDashboard")) {
        dataGen.getData($scope, {}, "/monitor/dashboard").then(
            function () {
                if ($scope.data.orderData && $scope.data.orderData.mainData) {
                    $scope.orderChartData = generateOrderData();
                }
                if ($scope.data.totalNetDataPeriod && $scope.data.totalNetDataPeriod.mainData) {
                    $scope.totalNetDataPeriod = generateTotalNetDataPeriod();
                }
                $timeout(function () {
                    if ($scope.data.quickStatsData) {
                        textFit($(".quickStat"));
                    }

                }, 0);

                defineButtons();
            }
        );
    }

    /* order chart */
    $scope.orderChartOptions = {
        chart: {
            type: 'lineChart',
            height: 400,
            margin: {
                top: 20,
                right: 80,
                bottom: 100,
                left: 80
            },
            x: function (d) {
                return d.position;
            },
            y: function (d) {
                return d.value;
            },
            reduceXTicks: false,
            transitionDuration: 500,
            xAxis: {
                rotateLabels: -30,
                axisLabel: '',
                tickFormat: function (x) {
                    return getOrderChartLabel(x);
                }
            },
            yAxis: {
                axisLabel: '',
                tickFormat: function (d) {
                    return formatNumber(d, pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, undefined);
                    //return d3.format('.')(d);
                },
                rotateYLabel: false
            }
            , forceY: [0],
            clipVoronoi: false
        }
    };

    var generateOrderData = function () {
        var data = [$scope.data.orderData.mainData.data];
        return data.map(function (data, i) {
            return {
                key: $scope.trns.numberOfOrders,
                values: data
            };
        });
    };

    var getOrderChartLabel = function (x) {
        if ($scope.data.orderData.mainData.data[x]) return $scope.data.orderData.mainData.data[x].label;
        return "";
    };

    /* total net chart */

    $scope.totalNetPeriodChartOptions = {
        chart: {
            type: 'lineChart',
            height: 400,
            margin: {
                top: 20,
                right: 80,
                bottom: 100,
                left: 80
            },
            x: function (d) {
                return d.position;
            },
            y: function (d) {
                return d.value;
            },
            reduceXTicks: false,
            transitionDuration: 500,
            xAxis: {
                rotateLabels: -30,
                axisLabel: '',
                tickFormat: function (x) {
                    return getTotalPeriodChartLabel(x);
                }
            },
            yAxis: {
                axisLabel: '',
                tickFormat: function (d) {
                    return formatNumber(d, pattern, formats.GROUP_SEP, formats.DECIMAL_SEP, undefined);
                    //return d3.format('.')(d);
                },
                rotateYLabel: false
            }
            , forceY: [0],
            clipVoronoi: false
        }
    };

    var generateTotalNetDataPeriod = function () {
        var data = [$scope.data.totalNetDataPeriod.mainData.data];
        return data.map(function (data, i) {
            return {
                key: $scope.trns.totalNetOrder,
                values: data
            };
        });
    };

    var getTotalPeriodChartLabel = function (x) {
        if ($scope.data.totalNetDataPeriod.mainData.data[x]) return $scope.data.totalNetDataPeriod.mainData.data[x].label;
        return "";
    };

    var textFit = function (items) {
        items.each(function () {
            var ourText = $("span", this);
            ourText.css(
                "fontSize", Math.min(320 / ourText[0].innerHTML.length, 30)
            );
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.newAnalysis,
                action: self.open,
                type: 'dialogaction',
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }
}
